import { render, staticRenderFns } from "./RightShipYearlyTable.vue?vue&type=template&id=5b16ad85&scoped=true&"
import script from "./RightShipYearlyTable.vue?vue&type=script&lang=js&"
export * from "./RightShipYearlyTable.vue?vue&type=script&lang=js&"
import style0 from "./RightShipYearlyTable.vue?vue&type=style&index=0&id=5b16ad85&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b16ad85",
  null
  
)

export default component.exports